'use client';

import * as React from 'react';
import TopupModalContent from '@/app/dashboard/players/components/topup-modal-content';
import { useAppSelector } from '@/store/hooks';
import { getUi } from '@/store/reducers/ui-slice';

import { ModalDrawer } from '@/types/general';

import { ModalLayout } from '../core/modal-layout';

export function TopupModal(): React.JSX.Element {
  const { modal } = useAppSelector(getUi);

  const content = modal?.content as {
    opId: string;
    playerId: string;
    playerCode: string;
  };

  return (
    <ModalLayout title="Topup" isOpen={modal?.open === ModalDrawer.TOPUP}>
      {modal?.content ? <TopupModalContent content={content} /> : null}
    </ModalLayout>
  );
}
